module.exports = __webpack_public_path__ + "static/billigprilla-meta-fc697ab95fe0a62858c8e7b6f34c95f0.png";